import React from 'react';
import { MessageCircle, MoreHorizontal, Share2, ThumbsUp, Pen, Smile, Camera, Image as ImageIcon, Sticker } from 'lucide-react';
export function Testimonials() {
  return <section className="py-20 px-4 bg-[#f0f2f5]" data-id="element-363">
      <div className="max-w-6xl mx-auto" data-id="element-364">
        {/* Branded Section Header */}
        <h2 className="text-3xl md:text-5xl font-bold text-center text-teal-500 mb-12 font-baloo drop-shadow-sm" data-id="element-365">
          ⭐ LO QUE DICEN LAS FAMILIAS QUE YA TIENEN SU KIT
        </h2>

        {/* Facebook Feed Container */}
        <div className="max-w-lg mx-auto" data-id="element-366">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 pt-3 pb-4" style={{
          fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
        }} data-id="element-367">
            {/* Product Post Header */}
            <div className="px-4 mb-3 flex items-start justify-between" data-id="element-368">
              <div data-id="element-369">
                <div className="text-[#65676b] text-[12px] font-semibold uppercase tracking-wide mb-0.5" data-id="element-370">
                  MUNDOINFANTILDIGITAL.SHOP
                </div>
                <h3 className="text-[#050505] text-[17px] font-bold leading-tight mb-1" data-id="element-371">
                  Crea Fiestas Mágicas en Casa 🪄
                </h3>
                <div className="flex items-center gap-1 text-[14px] text-[#65676b]" data-id="element-372">
                  <div className="flex text-yellow-400 text-[16px] tracking-tighter" data-id="element-373">
                    ★★★★★
                  </div>
                  <span data-id="element-374">5/5</span>
                </div>
              </div>
              <button className="bg-[#e4e6eb] hover:bg-[#d8dadf] text-[#050505] font-semibold text-[15px] px-4 py-1.5 rounded-md transition-colors" data-id="element-375">
                Comprar
              </button>
            </div>

            {/* Reactions Bar */}
            <div className="px-4 py-2 flex items-center justify-between text-[#65676b] text-[15px]" data-id="element-376">
              <div className="flex items-center gap-1.5" data-id="element-377">
                <div className="flex -space-x-1" data-id="element-378">
                  <div className="w-[18px] h-[18px] rounded-full bg-[#1877F2] flex items-center justify-center text-white text-[10px] ring-2 ring-white z-10" data-id="element-379">
                    👍
                  </div>
                  <div className="w-[18px] h-[18px] rounded-full bg-[#f33e58] flex items-center justify-center text-white text-[10px] ring-2 ring-white" data-id="element-380">
                    ❤️
                  </div>
                </div>
                <span className="hover:underline cursor-pointer" data-id="element-381">258</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-382">
                <span className="hover:underline cursor-pointer flex items-center gap-1" data-id="element-383">
                  345 <MessageCircle className="w-4 h-4" data-id="element-384" />
                </span>
                <span className="hover:underline cursor-pointer flex items-center gap-1" data-id="element-385">
                  89 <Share2 className="w-4 h-4" data-id="element-386" />
                </span>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="px-4" data-id="element-387">
              <hr className="border-[#ced0d4]" data-id="element-388" />
              <div className="flex items-center justify-between py-1" data-id="element-389">
                <button className="flex-1 flex items-center justify-center gap-2 py-1.5 text-[#65676b] font-semibold text-[15px] hover:bg-[#f2f2f2] rounded-md transition-colors" data-id="element-390">
                  <ThumbsUp className="w-5 h-5" data-id="element-391" />
                  Me gusta
                </button>
                <button className="flex-1 flex items-center justify-center gap-2 py-1.5 text-[#65676b] font-semibold text-[15px] hover:bg-[#f2f2f2] rounded-md transition-colors" data-id="element-392">
                  <MessageCircle className="w-5 h-5" data-id="element-393" />
                  Comentar
                </button>
                <button className="flex-1 flex items-center justify-center gap-2 py-1.5 text-[#65676b] font-semibold text-[15px] hover:bg-[#f2f2f2] rounded-md transition-colors" data-id="element-394">
                  <Share2 className="w-5 h-5" data-id="element-395" />
                  Compartir
                </button>
              </div>
              <hr className="border-[#ced0d4] mb-3" data-id="element-396" />
            </div>

            {/* Sort Dropdown */}
            <div className="px-4 mb-4" data-id="element-397">
              <button className="text-[#65676b] font-semibold text-[15px] hover:bg-[#f2f2f2] px-2 py-1 rounded-md transition-colors flex items-center gap-1" data-id="element-398">
                Más recientes <span className="text-[10px]" data-id="element-399">▼</span>
              </button>
            </div>

            {/* Comments List */}
            <div className="px-4 space-y-4" data-id="element-400">
              {/* Comment 1: Laura García */}
              <div data-id="element-401">
                <div className="flex items-start gap-2" data-id="element-402">
                  <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold text-[14px] flex-shrink-0 mt-1" data-id="element-403">
                    L
                  </div>
                  <div className="flex-1" data-id="element-404">
                    <div className="flex items-center gap-2" data-id="element-405">
                      <div className="bg-[#f0f2f5] rounded-2xl px-3 py-2 inline-block max-w-[90%]" data-id="element-406">
                        <div className="font-semibold text-[#050505] text-[13px] hover:underline cursor-pointer leading-tight mb-0.5" data-id="element-407">
                          Laura García
                        </div>
                        <div className="text-[#050505] text-[15px] leading-snug" data-id="element-408">
                          ¿Tiene diseños de Bluey y Cocomelon? Mi hija está
                          obsesionada con esos personajes 😍
                        </div>
                      </div>
                      <button className="w-8 h-8 rounded-full hover:bg-[#f2f2f2] flex items-center justify-center text-[#65676b] flex-shrink-0" data-id="element-409">
                        <MoreHorizontal className="w-5 h-5" data-id="element-410" />
                      </button>
                    </div>
                    <div className="flex items-center gap-3 text-[#65676b] text-[12px] font-semibold mt-1 ml-3" data-id="element-411">
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-412">
                        1 sem
                      </span>
                      <span className="hover:underline cursor-pointer" data-id="element-413">
                        Me gusta
                      </span>
                      <span className="hover:underline cursor-pointer" data-id="element-414">
                        Responder
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-415">
                        Ver traducción
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-416">
                        Ocultar
                      </span>
                    </div>
                  </div>
                </div>

                {/* Expanded Reply (KIT FIESTA MÁGICA) */}
                <div className="ml-10 mt-2" data-id="element-417">
                  <div className="flex items-start gap-2" data-id="element-418">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-teal-400 to-emerald-500 flex items-center justify-center text-white font-bold text-[8px] flex-shrink-0 mt-1 shadow-sm" data-id="element-419">
                      MD
                    </div>
                    <div className="flex-1" data-id="element-420">
                      <div className="flex items-center gap-2" data-id="element-421">
                        <div className="bg-[#f0f2f5] rounded-2xl px-3 py-2 inline-block max-w-[90%]" data-id="element-422">
                          <div className="flex items-center gap-1 text-[#65676b] text-[11px] font-semibold mb-0.5" data-id="element-423">
                            <Pen className="w-3 h-3" data-id="element-424" /> Autor
                          </div>
                          <div className="font-semibold text-[#050505] text-[13px] hover:underline cursor-pointer leading-tight mb-0.5" data-id="element-425">
                            MUNDO DECO
                          </div>
                          <div className="text-[#050505] text-[15px] leading-snug" data-id="element-426">
                            <span className="text-[#1877F2] hover:underline cursor-pointer bg-[#e7f3ff] px-0.5 rounded" data-id="element-427">
                              Laura García
                            </span>{' '}
                            ¡Sí! Tenemos más de 200 personajes incluyendo Bluey,
                            Cocomelon, Patrulla Canina y muchos más 🎉
                          </div>
                        </div>
                        <button className="w-8 h-8 rounded-full hover:bg-[#f2f2f2] flex items-center justify-center text-[#65676b] flex-shrink-0" data-id="element-428">
                          <MoreHorizontal className="w-5 h-5" data-id="element-429" />
                        </button>
                      </div>
                      <div className="flex items-center gap-3 text-[#65676b] text-[12px] font-semibold mt-1 ml-3" data-id="element-430">
                        <span className="font-normal hover:underline cursor-pointer" data-id="element-431">
                          1 sem
                        </span>
                        <span className="hover:underline cursor-pointer" data-id="element-432">
                          Me gusta
                        </span>
                        <span className="hover:underline cursor-pointer" data-id="element-433">
                          Responder
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Reply Input */}
                  <div className="flex items-center gap-2 mt-2" data-id="element-434">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-teal-400 to-emerald-500 flex items-center justify-center text-white font-bold text-[8px] flex-shrink-0 shadow-sm" data-id="element-435">
                      MD
                    </div>
                    <div className="flex-1 bg-[#f0f2f5] rounded-full px-3 py-1.5 flex items-center justify-between" data-id="element-436">
                      <span className="text-[#65676b] text-[13px]" data-id="element-437">
                        Responder como MUNDO DECO
                      </span>
                      <div className="flex items-center gap-2 text-[#65676b]" data-id="element-438">
                        <Smile className="w-4 h-4 cursor-pointer hover:text-[#050505]" data-id="element-439" />
                        <Camera className="w-4 h-4 cursor-pointer hover:text-[#050505]" data-id="element-440" />
                        <ImageIcon className="w-4 h-4 cursor-pointer hover:text-[#050505]" data-id="element-441" />
                        <Sticker className="w-4 h-4 cursor-pointer hover:text-[#050505]" data-id="element-442" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Comment 2: María Torres */}
              <div data-id="element-443">
                <div className="flex items-start gap-2" data-id="element-444">
                  <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center text-white font-bold text-[14px] flex-shrink-0 mt-1" data-id="element-445">
                    M
                  </div>
                  <div className="flex-1" data-id="element-446">
                    <div className="flex items-center gap-2" data-id="element-447">
                      <div className="bg-[#f0f2f5] rounded-2xl px-3 py-2 inline-block max-w-[90%]" data-id="element-448">
                        <div className="font-semibold text-[#050505] text-[13px] hover:underline cursor-pointer leading-tight mb-0.5" data-id="element-449">
                          María Torres
                        </div>
                        <div className="text-[#050505] text-[15px] leading-snug" data-id="element-450">
                          Lo compré ayer y ya imprimí todo para la fiesta de mi
                          hija. ¡Quedó increíble! Super fácil de usar desde el
                          celular
                        </div>
                      </div>
                      <button className="w-8 h-8 rounded-full hover:bg-[#f2f2f2] flex items-center justify-center text-[#65676b] flex-shrink-0" data-id="element-451">
                        <MoreHorizontal className="w-5 h-5" data-id="element-452" />
                      </button>
                    </div>
                    <div className="flex items-center gap-3 text-[#65676b] text-[12px] font-semibold mt-1 ml-3" data-id="element-453">
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-454">
                        3 sem
                      </span>
                      <span className="text-[#1877F2] hover:underline cursor-pointer" data-id="element-455">
                        Me gusta
                      </span>
                      <span className="hover:underline cursor-pointer" data-id="element-456">
                        Responder
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-457">
                        Ver traducción
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-458">
                        Ocultar
                      </span>
                      <div className="w-[16px] h-[16px] rounded-full bg-[#1877F2] flex items-center justify-center text-white text-[9px] ring-2 ring-white ml-auto mr-4" data-id="element-459">
                        👍
                      </div>
                    </div>
                  </div>
                </div>
                {/* Collapsed Reply */}
                <div className="ml-10 mt-1 flex items-center gap-2 cursor-pointer hover:underline" data-id="element-460">
                  <div className="w-5 h-5 rounded-full bg-gradient-to-br from-teal-400 to-emerald-500 flex items-center justify-center text-white font-bold text-[7px] shadow-sm" data-id="element-461">
                    MD
                  </div>
                  <span className="text-[#65676b] font-semibold text-[13px]" data-id="element-462">
                    MUNDO DECO respondió · 1 respuesta
                  </span>
                </div>
              </div>

              {/* Comment 3: Carmen Rodríguez */}
              <div data-id="element-463">
                <div className="flex items-start gap-2" data-id="element-464">
                  <div className="w-8 h-8 rounded-full bg-purple-500 flex items-center justify-center text-white font-bold text-[14px] flex-shrink-0 mt-1" data-id="element-465">
                    C
                  </div>
                  <div className="flex-1" data-id="element-466">
                    <div className="flex items-center gap-2" data-id="element-467">
                      <div className="bg-[#f0f2f5] rounded-2xl px-3 py-2 inline-block max-w-[90%]" data-id="element-468">
                        <div className="font-semibold text-[#050505] text-[13px] hover:underline cursor-pointer leading-tight mb-0.5" data-id="element-469">
                          Carmen Rodríguez
                        </div>
                        <div className="text-[#050505] text-[15px] leading-snug" data-id="element-470">
                          ¿Me pueden enviar un mensaje? Quiero saber si se puede
                          personalizar con el nombre de mi hijo
                        </div>
                      </div>
                      <button className="w-8 h-8 rounded-full hover:bg-[#f2f2f2] flex items-center justify-center text-[#65676b] flex-shrink-0" data-id="element-471">
                        <MoreHorizontal className="w-5 h-5" data-id="element-472" />
                      </button>
                    </div>
                    <div className="flex items-center gap-3 text-[#65676b] text-[12px] font-semibold mt-1 ml-3" data-id="element-473">
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-474">
                        5 sem
                      </span>
                      <span className="text-[#1877F2] hover:underline cursor-pointer" data-id="element-475">
                        Me gusta
                      </span>
                      <span className="hover:underline cursor-pointer" data-id="element-476">
                        Responder
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-477">
                        Ver traducción
                      </span>
                      <span className="font-normal hover:underline cursor-pointer" data-id="element-478">
                        Ocultar
                      </span>
                      <div className="w-[16px] h-[16px] rounded-full bg-[#1877F2] flex items-center justify-center text-white text-[9px] ring-2 ring-white ml-auto mr-4" data-id="element-479">
                        👍
                      </div>
                    </div>
                  </div>
                </div>
                {/* Collapsed Reply */}
                <div className="ml-10 mt-1 flex items-center gap-2 cursor-pointer hover:underline" data-id="element-480">
                  <div className="w-5 h-5 rounded-full bg-gradient-to-br from-teal-400 to-emerald-500 flex items-center justify-center text-white font-bold text-[7px] shadow-sm" data-id="element-481">
                    MD
                  </div>
                  <span className="text-[#65676b] font-semibold text-[13px]" data-id="element-482">
                    MUNDO DECO respondió · 1 respuesta
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}